import { TTicketDetails } from "@daymade/api-contracts";

/** When given a list of all tickets for a player, filters those tickets to the specified drawType, then computes the
 * number of entries that the player is still allowed to buy
 * 
 * If maxPlayerEntries is non-null, then the result is the number of entries that the player has remaining.
 * 
 * If maxPlayerEntries is null, then null is returned. This means the player can enter as many times as possible.
 */
export const getNumberOfEntriesAvailableToPlayer = (
  activeTickets: TTicketDetails[],
  drawType: string,
  maxPlayerEntries: number | null
) => {
  if (maxPlayerEntries === null) return null;

  const totalEntries = getNumberOfTicketEntriesForDrawType(activeTickets, drawType);

  return Math.max(maxPlayerEntries - totalEntries, 0);
};

/** Gets the number of entries for the specified drawType */
export const getNumberOfTicketEntriesForDrawType = (
  activeTickets: TTicketDetails[],
  drawType: string,
) => {
  const totalEntries = activeTickets
    .filter((ticket) => ticket.drawType.code === drawType)
    .reduce((sum, ticket) => sum + ticket.entries.length, 0);

  return totalEntries;
};

